import React from "react";
import { Helmet } from "react-helmet";

export default function About() {
  return (
    <div style={{
      maxWidth: "900px",
      margin: "20px auto",
      padding: "20px 15px",
      fontFamily: "Arial, sans-serif",
      lineHeight: "1.8",
      color: "#1a1a1a",
      backgroundColor: "#fdfdfd",
      borderRadius: "8px",
      boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
    }}>
      {/* SEO Meta */}
      <Helmet>
        <title>About SamSoftix GameHub | Developer Qasim Mehmood Cheema</title>
        <meta name="description" content="Learn about SamSoftix GameHub, your futuristic online mini-game hub. Developed by Qasim Mehmood Cheema, offering classic games with modern enhancements." />
        <meta name="keywords" content="GameHub, SamSoftix, online mini games, developer Qasim Mehmood Cheema, browser games, online gaming platform" />
      </Helmet>

      {/* Hero Section */}
      <header style={{ textAlign: "center", marginBottom: "40px" }}>
        <h1 style={{ fontSize: "2rem", fontWeight: "700", color: "#0d47a1" }}>
          About <span style={{ textShadow: "0 0 10px #00e5ff, 0 0 20px #00b8d4" }}>SamSoftix GameHub</span>
        </h1>
        <p style={{ fontSize: "1rem", marginTop: "10px", color: "#333" }}>
          SamSoftix GameHub is your futuristic playground for online mini-games.
          Experience classic games with a modern, neon twist. Play, challenge, and compete with friends worldwide.
        </p>
      </header>

      {/* Mission Section */}
      <section style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "1.5rem", marginBottom: "10px", color: "#0d47a1" }}>Our Mission</h2>
        <p style={{ fontSize: "1rem", color: "#333" }}>
          To deliver fun, engaging, and futuristic mini-games for everyone.
          We aim to combine nostalgia and modern technology, giving players an immersive, seamless gaming experience.
        </p>
      </section>

      {/* Vision Section */}
      <section style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "1.5rem", marginBottom: "10px", color: "#0d47a1" }}>Our Vision</h2>
        <p style={{ fontSize: "1rem", color: "#333" }}>
          To become the go-to online hub for mini-games worldwide, inspiring creativity, fun, and collaboration in a visually stunning cyber universe.
        </p>
      </section>

      {/* History Section */}
      <section style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "1.5rem", marginBottom: "10px", color: "#0d47a1" }}>Our History</h2>
        <p style={{ fontSize: "1rem", color: "#333" }}>
          Founded in 2023, SamSoftix started as a small project focused on reviving classic browser games.
          Over time, it has evolved into a dynamic online gaming platform, offering a variety of mini-games with modern graphics, responsive gameplay, and immersive features for players of all ages.
        </p>
      </section>

      {/* Core Values Section */}
      <section style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "1.5rem", marginBottom: "10px", color: "#0d47a1" }}>Core Values</h2>
        <ul style={{ paddingLeft: "20px", fontSize: "1rem", color: "#333" }}>
          <li>Fun & Entertainment: Every game is designed to bring joy.</li>
          <li>Innovation: Combining classic gameplay with modern technology.</li>
          <li>Accessibility: Games available anytime, anywhere, on all devices.</li>
          <li>Community: Engaging players and building a vibrant gaming community.</li>
          <li>Integrity: Honest, safe, and transparent gaming experience.</li>
        </ul>
      </section>

      {/* Why Choose Us Section */}
      <section style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "1.5rem", marginBottom: "10px", color: "#0d47a1" }}>Why Choose SamSoftix GameHub</h2>
        <p style={{ fontSize: "1rem", color: "#333" }}>
          With a unique mix of classic and modern mini-games, a responsive design for all devices,
          and a commitment to user enjoyment and safety, SamSoftix GameHub provides an unmatched
          online gaming experience.
        </p>
      </section>

      {/* Community & Future Plans Section */}
      <section style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "1.5rem", marginBottom: "10px", color: "#0d47a1" }}>Community & Future Plans</h2>
        <p style={{ fontSize: "1rem", color: "#333" }}>
          We are growing a global community of gamers, adding multiplayer features, tournaments,
          interactive challenges, and regular updates. Players are encouraged to share feedback,
          suggest games, and participate in shaping the future of GameHub.
        </p>
      </section>

      {/* Developer Section */}
      <section style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "1.5rem", marginBottom: "10px", color: "#0d47a1" }}>About the Developer</h2>
        <p style={{ fontSize: "1rem", color: "#333" }}>
          SamSoftix GameHub is developed by <strong>Qasim Mehmood Cheema</strong>, a passionate full-stack developer and gamer.
          With expertise in React.js, JavaScript, and web development, Qasim created GameHub to bring classic online games 
          to modern devices with improved graphics, performance, and user experience.
        </p>
        <p style={{ fontSize: "1rem", color: "#333" }}>
          Qasim’s vision is to combine education, fun, and technology to create a global gaming platform accessible to everyone.
          He actively engages with the community to continuously improve and expand the GameHub experience.
        </p>
      </section>

      {/* Optional Footer Note */}
      <p style={{ marginTop: "40px", fontSize: "0.875rem", color: "#555", textAlign: "center" }}>
        © {new Date().getFullYear()} SamSoftix GameHub. All rights reserved.
      </p>
    </div>
  );
}
